module.exports = __webpack_public_path__ + "assets/0148ec9e0eca2f004d96763a53cefc28.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/resources/icons/icons-16.ttf
// module id = 3630
// module chunks = 0